export default __webpack_public_path__ + "static/media/bank_alfa.2fc77a1a.svg";